import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useEffect, useState } from 'react';
import InventoryTile from '../../components/tenants/inventory-tile';
import TenantApi from '../../api/tenant/tenant-api-factory';

export const InventoriesList = () => {
    const { id, tenancyIndex } = useParams();
    const { instance, inProgress, accounts } = useMsal();

    const [tenant, setTenant] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const tenantApi = new TenantApi(instance, inProgress, accounts, false);
        let mounted = true;

        async function load() {
            setLoading(true);
            try {
                const t = await tenantApi.get(id);
                if (!mounted) return;
                setTenant(t);
            } catch (err) {
                console.error('InventoriesList: Failed to load tenant', err);
            } finally {
                if (mounted) setLoading(false);
            }
        }
        load();

        return () => { mounted = false; };
    }, [id, instance, inProgress, accounts]);

    if (loading) return <div>Loading...</div>;
    if (!tenant) return <div>Tenant not found</div>;

    const tenancy = (tenant.tenancies || [])[parseInt(tenancyIndex) || 0];
    if (!tenancy) return <div>Tenancy not found</div>;
    
    return (
        <div className="p-3">
            <div className="mb-2">
                <div className="d-flex justify-content-between align-items-center mb-2">
                    <div>
                        <button className="btn btn-sm btn-secondary me-2" onClick={() => window.history.length > 1 ? window.history.back() : null}>Back</button>
                        <Link className="btn btn-sm btn-outline-primary" to={`/tenant/detail/${id}/tenancies`}>Back to tenant</Link>
                    </div>
                </div>
            </div>
            <h3>Inventories for {tenant.displayName} — Tenancy #{parseInt(tenancyIndex) + 1}</h3>
            <div className="mb-3">
                <Link to={`/tenant/detail/${id}/inventory/new?tenancyIndex=${tenancyIndex}&type=periodic`} className="btn btn-primary">Add Inventory</Link>
            </div>

            <div className="row">
                {(tenancy.inventories || []).map(inv => (
                    <div key={inv.id} className="col-12 col-sm-6 col-md-4 mb-3">
                        <InventoryTile inventory={inv} tenantId={id} tenantDisplayName={tenant.displayName} />
                    </div>
                ))}

                {(!tenancy.inventories || tenancy.inventories.length === 0) && (
                    <div className="col-12 text-muted">No inventories</div>
                )}
            </div>
        </div>
    );
}

export default InventoriesList;
